import { StyledType, createComponent } from '@workday/canvas-kit-react/common';
import { Toast } from '@workday/canvas-kit-react/toast';
import { WcpStyles } from '@workday/wcp-tokens';
import React, { Ref } from 'react';
import { ThemedTertiaryButton } from './ThemedTertiaryButton';

export const ThemedToastMessage = createComponent('p')({
  Component: (
    props: React.ComponentProps<typeof Toast.Message> & StyledType,
    ref: Ref<HTMLParagraphElement>,
    Element
  ) => <Toast.Message ref={ref} as={Element} color={WcpStyles.color.text.default} {...props} />,
});

const ThemedCloseIcon: React.FC<React.ComponentProps<typeof Toast.CloseIcon>> = createComponent(Toast.CloseIcon)({
  Component: (
    props: React.ComponentProps<typeof Toast.CloseIcon> & StyledType,
    ref: Ref<HTMLButtonElement>,
    Element
  ) => <ThemedTertiaryButton as={Element} ref={ref} size='small' {...props} />,
});

export const ThemedToast = createComponent()({
  displayName: 'ThemedToast',
  Component: (props: React.ComponentProps<typeof Toast>) => (
    <Toast {...props} backgroundColor={WcpStyles.color.bg.default} borderColor={WcpStyles.color.border.container} />
  ),
  subComponents: {
    Body: Toast.Body,
    Icon: Toast.Icon,
    Message: ThemedToastMessage,
    Link: Toast.Link,
    CloseIcon: ThemedCloseIcon,
  },
});
